<template>
  <!-- 休日出勤管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>休日出勤報告</span>
        <span class="card-header-actions">
          <!-- 休日出勤報告登録画面へ遷移するボタン -->
          <router-link :to="{ name: holidayWorksRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li class="preika-form-message" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <div class="table-responsive">
        <table class="table table-bordered preika-report-list-table">
          <thead>
            <tr>
              <th scope="col" class="title">ステータス</th>
              <th scope="col">申請日</th>
              <th scope="col">日付</th>
              <th scope="col">開始予定時間</th>
              <th scope="col">終了予定時間</th>
              <th scope="col">発生理由</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="preika-report-list-table__status">
                <span class="preika-report-status">報告済</span>
              </td>
              <td class="preika-report-list-table__date">
                <router-link
                  :to="{ name: holidayWorksInfo, params: { id: item.id } }"
                  >{{ formatDate(item.updated_at) }}</router-link
                >
              </td>
              <td class="preika-report-list-table__date">{{ formatDate(item.date) }}</td>
              <td class="preika-report-list-table__time">
                {{ formatTime(item.start_time) }}
              </td>
              <td class="preika-report-list-table__time">
                {{ formatTime(item.end_time) }}
              </td>
              <td class="preika-report-list-table__reason">{{ item.reason }}</td>
              <td class="preika-report-list-table__actions">
                <save-button
                  :label="'削除'"
                  :loading="loading"
                  @click="deleteOvertime(item.id)"
                  class="btn btn-danger"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-page="currentPage"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import VPagination from "vuejs-paginate";
import SaveButton from "./../../common/SaveButton";
export default {
  name: "List",
  components: {
    VPagination,
    SaveButton,
  },
  data() {
    return {
      showModal: false,
      postItem: "",
      items: [],
      employee_id: [],
      deleted_flg: [],
      authority: [],
      errors: [],
      holidayWorksRegister: "",
      holidayWorksInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.holidayWorksRegister = ConstList.ROUTE_HOLIDAYWORKS_REGISTER;
    this.holidayWorksInfo = ConstList.ROUTE_HOLIDAYWORKS_INFO;
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },

  methods: {
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/holidayWork", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          this.items = response.data;
          if (this.items.length === 0) {
            this.errors.push(ConstList.EMPTY);
          }
          this.items.forEach((element) => {
            element.updated_at = element.updated_at.slice(0, 10);
          });
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },
    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    formatTime(timeString) {
      if (!timeString) return "";

      // 時間文字列をパースして、時間と分を抽出
      const [hours, minutes] = timeString.split(":");
      return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/holidayWorkCount")
        .then((response) => {
          const totalCount = response.data;
          // 0件でもページャを消さない。切り上げただけだと 0 ページになり、ページャごと消える。
          this.totalPages = Math.max(1, Math.ceil(totalCount / this.pageSize));
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },
    // 休日出勤報告を削除
    deleteOvertime: function (id) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      if (confirm("削除してもよろしいですか？")) {
        //フラグがfalseならば、フラグをtrueにしたうえでsubmit
        this.loading = true;
        this.submit_flg = true;
        const params = new URLSearchParams();
        params.append("id", id);
        axios
          .post(process.env.VUE_APP_API_ORIGIN + "/holidayWorkDelete", params)
          .then(() => {
            this.submit_flg = false;
            alert(ConstList.DELETE_MESSAGE);
            this.showModal = false;
            window.location.reload();
          })
          .catch((error) => {
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
};
</script>
